export default "__VITE_ASSET__BElENzvM__"